import client from "./client";

export default {
    async getProperties(filters) {
        return client.parseResponse(await client.get('/properties', filters));
    },
    async getUserProperties(filters) {
        return client.parseResponse(await client.get('/user-properties', filters));
    },

    async generatePNR(filters) {
        return client.parseResponse(await client.post('/generate-pnr', filters));
    },

    async getErits(filters) {
        return client.parseResponse(await client.get('/e-rits', filters));
    },
    async createProperty(data) {
        return client.parseResponse(await client.post('/add-property', data))
    },

    async createOnboarding(data) {
        return client.parseResponse(await client.post('/onboarding', data))
    },

    async getOnboardingClient(data) {
        return client.parseResponse(await client.post('/onboarding-client', data))
    },

    async assignProperty(data) {
        return client.parseResponse(await client.post('/assign-property', data))
    },

    async getProperty(id) {
        return client.parseResponse(await client.get('/properties/' + id));
    },
    async editProperty(data) {
        return client.parseResponse(await client.put('/properties/' + data.id, data))
    },

    async editPropertyFormData(data) {
        return client.parseResponse(await client.post('/properties/' + data.get('id') + "?_method=PUT", data, {
            contentType: 'application/x-www-form-urlencoded'
        }))
    },

    async deleteProperty(data) {
        return client.parseResponse(await client.delete('/properties/' + data.id, data))
    },

    async exportPropertiesReport(filters) {
        return client.parseResponse(await client.get('/export-properties', filters, {responseType: 'blob'}));
    }
}
